import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { ratingValues } from '../../../constants/workers';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar } from '@fortawesome/free-solid-svg-icons';

export default class Rating extends PureComponent {
  render () {
    return (
      <div className={`d-flex align-items-center ${this.props.disabled ? 'disabled' : ''}`}>
        {ratingValues.map(ratingValue => (
          <button
            type='button'
            key={ratingValue}
            className={`btn-rate ${this.props.buttonClassName}`}
            data-active={this.props.value >= ratingValue}
            onClick={() => this.props.setRating(ratingValue)}>
            <FontAwesomeIcon icon={faStar} />
          </button>
        ))}
      </div>
    );
  }
}

Rating.propTypes = {
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  setRating: PropTypes.func,
  disabled: PropTypes.bool,
  buttonClassName: PropTypes.string
};

Rating.defaultProps = {
  buttonClassName: ''
};



// WEBPACK FOOTER //
// ./src/components/common/ui/Rating.js